import { RadioactiveIcon } from './RadioactiveIcon';

/**
 * author: Yasmina Lembachar
 * id D70016AF-1FEE-4E66-8D51-3DE1BAAC0031
 * name radioactive
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radioactive.svg
 * tags
 * - Science 
 */
export const RadiationIcon = RadioactiveIcon;
export default RadiationIcon